import { UserInfoContext } from "Context/CommonContext";
import { DatePicker, Form, Select } from "antd";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { selectInterface } from "utilFunctions/shared/MultiSearchBar";
interface FacultiesRegionsFilterIF {
  filterState: any;
  setFilterState: any;
  dates: any;
  setDates: any;
}
const { RangePicker } = DatePicker;
export const getFieldByVal = (arr: any[], val: any) => {
  const findVal = arr.find((ele: any) => ele.value == val);
  return findVal;
};
const FacultiesRegionsFilter = ({
  filterState,
  setFilterState,
  dates,
  setDates,
}: FacultiesRegionsFilterIF) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const [stream, setStream] = useState<selectInterface[]>(
    userInfo?.userStreams ? userInfo?.userStreams : []
  );
  useEffect(() => {
    setStream(userInfo?.userStreams as any);
  }, [userInfo, userInfo?.userStreams]);
  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
    if (name === "yearMonth") {
      setDates(val);
    }
  };
  return (
    <Form layout={"vertical"} className="w-100">
      <Form.Item label="Stream">
        <Select
          showSearch
          value={filterState.streamIds}
          style={{ width: "100%" }}
          size="large"
          options={stream}
          onChange={(selected: any) => {
            handleAddFilterArrayList(
              "streamIds",
              getFieldByVal(stream, selected)
            );
          }}
        />
      </Form.Item>
      <Form.Item label="Target Month">
        <RangePicker
          format={"MMM YY"}
          picker="month"
          value={dates}
          minDate={dayjs().subtract(11, "months").startOf("month")}
          maxDate={dayjs().endOf("month")}
          size="large"
          style={{ width: "100%" }}
          allowClear={false}
          onChange={(date: any) => {
            handleAddFilterArrayList("yearMonth", date);
          }}
        />
      </Form.Item>
    </Form>
  );
};

export default FacultiesRegionsFilter;
